import React from 'react'
import styled from 'styled-components'

import getNfcLocked from '../charge-point/getNfcLocked'
import getInstallationPhaseMode from '../charge-point/getInstallationPhaseMode'
import useText from '../../common/hooks/useText'
import { ChargePoint, Connector } from '../../common/redux/api/web-api'

const SInfoItem = styled.span`
    margin-right: 3px;
`

export type AuraConnectorInfoProps = {
    chargePoint: ChargePoint
    connector: Connector
}

export function AuraConnectorInfo({ chargePoint, connector }: AuraConnectorInfoProps): React.ReactElement {
    const text = useText()
    const nfcLocked = getNfcLocked(chargePoint, connector)
    const installationPhaseMode = getInstallationPhaseMode(chargePoint)
    const installationPhase = connector?.installationPhase
    const installationCurrent = connector?.installationCurrent

    return (
        <div>
            {nfcLocked && (
                <SInfoItem className="fa fa-lock grayFont" title={text('msgRFIDLockEnabled')} data-testid="nfcLocked" />
            )}
            {!nfcLocked && (
                <SInfoItem
                    className="fa fa-unlock grayFont"
                    title={text('msgRFIDLockDisabled')}
                    data-testid="nfcUnlocked"
                />
            )}
            {installationPhaseMode === '1P' && (
                <SInfoItem title={text('msgOnePhaseChargepoint')}>
                    1P ({installationPhase} - {installationCurrent} A)
                </SInfoItem>
            )}
            {installationPhaseMode === '3P' && (
                <SInfoItem title={text('msgThreePhaseChargepoint')}>3P ({installationCurrent} A)</SInfoItem>
            )}
            {chargePoint.additionalInfo?.partnerAccessible && (
                <SInfoItem
                    className="fa fa-bus darkBlueFont"
                    title={text('msgPartnerAccessible')}
                    data-testid="partnerAccessible"
                />
            )}
        </div>
    )
}
